import { render, staticRenderFns } from "./NextArrowButton.vue?vue&type=template&id=54960be8&"
import script from "./NextArrowButton.vue?vue&type=script&lang=js&"
export * from "./NextArrowButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports